import { DataDownloadMessages } from '../types';

export const dataDownloadHI: DataDownloadMessages = {
  'app.datadownload.checkbox.study_abroad': 'विदेश में पढ़ाई',
  'app.datadownload.checkbox.additional_demographics_info': 'अतिरिक्त जनसांख्यिकी',
  'app.datadownload.checkbox.remove_anonymous_user': 'अनाम उपयोगकर्ताओं को हटाएँ',
}